<div class="home__featuredbrands__container">
  <h2>{{ 'home.brands.title' | translate }}</h2>
  <div class="featuredbrands__list">
    <div class="featuredbrands__item" *ngFor="let brand of featuredBrand?.items">
      <img [src]="getImage(brand.imageUrl)" [alt]="brand.name" class="brand-logo" />
    </div>
  </div>
</div>
